export default __webpack_public_path__ + "static/media/BearFamily_07.ac3fee52.png";